import { theme } from 'antd';
import type { GlobalToken } from 'antd';
import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';
import { typography } from '../../theme/typography';

export type SectionTitleProps = {
  /** Title text. */
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

/**
 * SectionTitle — the title of a page section or a section card: heading-4
 * size, regular weight, in the theme's font and heading color.
 *
 * @example
 * ```tsx
 * import { SectionTitle } from '@libertify/ui';
 *
 * <SectionTitle>Education</SectionTitle>
 * ```
 */
export const SectionTitle = ({
  children,
  className,
  style,
}: SectionTitleProps) => {
  const { token } = theme.useToken();

  return (
    <StyledSectionTitle $token={token} className={className} style={style}>
      {children}
    </StyledSectionTitle>
  );
};

export default SectionTitle;

// ─── Styled components ───

const StyledSectionTitle = styled.h4<{ $token: GlobalToken }>`
  margin: 0;
  font-family: ${({ $token }) => $token.fontFamily};
  font-size: ${({ $token }) => $token.fontSizeHeading4}px;
  font-weight: ${typography.fontWeight.regular};
  line-height: ${({ $token }) => $token.lineHeightHeading4};
  color: ${({ $token }) => $token.colorTextHeading};
`;
